import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import TermsDropdown from '../../common/components/TermsDropdown';
import GradesDropdown from '../../common/components/GradesDropdown';
import { withNamespaces, Trans } from 'react-i18next';
import moment from 'moment';
import WeekdaysDropdown from '../../common/components/WeekdaysDropdown';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';

class TimetableSearchForm extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { cities, centers, terms, grades, selectedCity, selectedCenter, selectedTerm, selectedGrades,
			franchisorDisplayName, selectedWeekday, showWeekdays, t } = this.props;
		//const cityCenters = selectedCity ? centers.filter(x => x.city === selectedCity) : centers;

		return <div>
			{/*<h3>{franchisorDisplayName && `${franchisorDisplayName}: `}{t('FO_TimetableSearch_InfoMessage')}</h3>*/}
			<h3>
				<Trans i18nKey='FO_TimetableSearch_InfoMessage_Center'>
					Select term to view available classes in <CenterDetailsLink center={selectedCenter} hideMapMarker />
				</Trans>
			</h3>
			<ButtonToolbar className='timetable-search'>
				{/*<DropdownButton id='timetableSearchCity' onSelect={key => this.props.onSelectCity(key)}*/}
				{/*	className='btn-block-xxs'*/}
				{/*	bsStyle={selectedCity ? 'primary' : 'default'}*/}
				{/*	title={selectedCity ? selectedCity : t('FO_TimetableSearch_City')}*/}
				{/*>*/}
				{/*	{cities && cities.sort().map(city => <MenuItem key={city} eventKey={city} >{city}</MenuItem>)}*/}
				{/*</DropdownButton>*/}
				{/*<DropdownButton id='timetableSearchCenter' onSelect={key => this.props.onSelectCenter(key)}*/}
				{/*	className='btn-block-xxs'*/}
				{/*	bsStyle={selectedCenter ? 'primary' : 'default'}*/}
				{/*	title={selectedCenter ? selectedCenter.name : t('FO_TimetableSearch_Center')}*/}
				{/*>*/}
				{/*	{cityCenters.map(center => <MenuItem key={center.id} eventKey={center.id} >{center.name}</MenuItem>)}*/}
				{/*</DropdownButton>*/}
				<TermsDropdown id='timetableSearchTerm'
					terms={terms}
					selectedTerm={selectedTerm}
					onSelectTerm={this.props.onSelectTerm}
				/>
				<GradesDropdown id='timetableSearchGrades'
					grades={grades.sort((a, b) => a.fromAge < b.fromAge ? -1 : 1)}
					selectedGrades={selectedGrades}
					onSelectGrades={this.props.onSelectGrades}
				/>
				{showWeekdays && <WeekdaysDropdown id='timetableSearchWeekday'
					selectedWeekday={selectedWeekday}
					onSelectWeekday={this.props.onSelectWeekday}
				/>}
			</ButtonToolbar>
		</div>;
	}
}

TimetableSearchForm.propTypes = {
	franchisorDisplayName: PropTypes.string,
	//cities: PropTypes.arrayOf(PropTypes.string),
	//centers: PropTypes.arrayOf(PropTypes.shape({
	//	id: PropTypes.number,
	//	name: PropTypes.string
	//})),
	terms: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	grades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	//selectedCity: PropTypes.string,
	selectedCenter: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	selectedTerm: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	selectedGrades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	selectedWeekday: PropTypes.string,
	//onSelectCity: PropTypes.func.isRequired,
	//onSelectCenter: PropTypes.func.isRequired,
	onSelectTerm: PropTypes.func.isRequired,
	onSelectGrades: PropTypes.func.isRequired,
	onSelectWeekday: PropTypes.func,
	showWeekdays: PropTypes.bool
};

export default withNamespaces()(TimetableSearchForm);